import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<import('modules/statistics/types').CustomerOpinionReducer>} */
const initialState = [];

/**
 * @param {Array<import('modules/statistics/types').CustomerOpinionReducer>} _
 * @param {import('modules/statistics/types').FetchCustomerOpinionStatsSuccessAction} action
 * @returns {Array<import('modules/statistics/types').CustomerOpinionReducer>}
 */
const updateAllData = (_, { payload }) => payload.content;

export default createReducer(initialState, {
  [types.FETCH_CUSTOMER_OPINION_STATS_SUCCESS]: updateAllData,
});
